import React, {Component} from "react";
import config from 'react-global-configuration';
import axios from "axios";
import {BeatLoader} from "react-spinners";
import { override } from '../helpers/utils.js';

class UtidFilter extends Component{
    constructor(props) {
        super(props);
        this.state ={
            ciutidList: [],
            ciutidValue: null,
            ciutidIds: '',
            is_utid_loading: true,
            listOpen: false,
            headerTitle: "Select [Utid]",
//             object_code:[],
//             storeObject:[],
//             search_object_code:[],

        }
        this.close = this.close.bind(this);
    }

    componentDidUpdate() {
        const { listOpen } = this.state;
        setTimeout(() => {
            if (listOpen) {
                window.addEventListener('click', this.close);
            } else {
                window.removeEventListener('click', this.close);
            }
        }, 0);
    }

    componentDidMount() {
        if(this.props.object_type==='Innoviti' && this.props.user_type ==='Internal') {
            this.ci_utid('','','',false,'');
        } else if(this.props.object_type==='Merchant'){
            this.ci_utid(this.props.object_code,'','',false,'');
        } else if(this.props.object_type==='Chain'){
            this.ci_utid('',this.props.object_code,'',false,'');
        }
        else if(this.props.object_type==='Store'){
            this.ci_utid('','',this.props.object_code,false,'');
        }
    }
    restUtidFilter(){
        this.setState({
            ciutidIds: [],
        })
    }
    ci_utid(mid,cid,sid,is_search, search_value) {
        if(is_search===false){
            this.setState({
                ciutidIds:[]
            })
        }
        this.setState({
            merchantID:mid,
            chainID:cid,
            storeID:sid
        })
        let utidList = [];
        let selected_val = '';
        if(is_search===true){
            selected_val = this.state.ciutidIds
        }
        this.setState({
            ciutidList: [],
            is_utid_loading: true
        })
        axios.post(config.get('API_URL') + '/reports/get-utid/', {

                mid: mid,
                cid: cid,
                sid: sid,
                is_search:is_search,
                search_value: search_value,
                selected_value: selected_val
            },
            {
                headers: {
                    Authorization: ` ${localStorage.usertoken}`
                }
            }).then(response => {

            if (Array.isArray(response.data) && response.data.length) {
                response.data.map((ci_utid, index) => {
                    utidList.push(ci_utid.utid)
                });
                if (Array.isArray(this.state.ciutidIds) && this.state.ciutidIds) {
                    utidList = utidList.filter( ( el ) => !this.state.ciutidIds.includes( el ) );
                    this.state.ciutidIds.map((ut,index) => {
                        utidList = [ut, ...utidList.filter(item => item !== ut)];
                    })

                }
                this.setState({
                    ciutidList: utidList,
                    is_utid_loading: false
                })

            } else {

                this.setState({
                    ciutidList: [],
                    is_utid_loading: false
                })
            }

        });
    }

    changeUtid(utid,checked_item, e){
        let item_list = this.state.ciutidIds
        let checked_list = utid;
        //console.log(checked_list);
        if(checked_item===false) {
            const newData = [utid, ...this.state.ciutidList.filter(item => item !== utid)];
            this.setState({
                ciutidIds: [...this.state.ciutidIds,  utid],
                isChange: true,
                ciutidList: newData
            });

        } else{
            let index = item_list.indexOf(checked_list);
            if (index > -1) {
                item_list.splice(index, 1);
                if(item_list.length<1) {
                    item_list='';
                }
                this.setState({
                    ciutidIds: item_list,
                    isChange: true
                })
            }
        }
        setTimeout(function() {
           this.props.onSelectUtid(this.state.ciutidIds);
        }.bind(this), 200);

        if (e.target.type === 'checkbox') {
            e.stopPropagation();
        }
    }

    filterList(e){
        var value = e.target.value
        setTimeout(function() {
            this.ci_utid(this.state.merchantID, this.state.chainID, this.state.storeID, true, value);
        }.bind(this), 200);
    }
    toggleList() {
        this.setState({
            listOpen: !this.state.listOpen,
        });
    }
    close() {
        this.setState({
            listOpen: false,
        });
    }

    render() {
        const utid_lists = this.state.ciutidList.map((utid_object, index) => {
            var chk_input = <input type='checkbox' checked={false}/>
            var activeCls = 'dd-list-item';
            var checked_item = false;
            if(this.state.ciutidIds.includes(utid_object) === true){
                chk_input = <input type='checkbox' checked={true}/>
                activeCls = "dd-list-item dd-list-active";
                checked_item = true;
            }
            return (
                <li key={index} className={activeCls} onClick={this.changeUtid.bind(this, utid_object,checked_item)}>
                    {chk_input}
                    &nbsp;&nbsp;{utid_object}
                </li>
            )
        })

        return(

            <div className="dd-wrapper">
                <div className="dd-header" onClick={() => this.toggleList()}>
                    {this.state.ciutidIds==''?
                        <div className="dd-header-title">{this.state.headerTitle}</div>:
                        <div className="dd-header-title">{this.state.ciutidIds.length} Selected</div>
                    }

                    <i className="fa fa-angle-down"></i>
                </div>
                {this.state.listOpen ===true?
                    <div
                        role="list"
                        onClick={(e) => e.stopPropagation()}
                    >
                        <input
                            className="dd-list-search-bar"
                            placeholder="Search"
                            onChange={(e) => this.filterList(e)}
                        />
                        <i className="fa fa-search" style={{position:"absolute", left:"195px",color: "rgb(204, 204, 204)", marginTop:"5px", zIndex:2}}></i>

                        {/*<div className="dd-scroll-list">*/}
                        <ul className="dd-list">
                            {this.state.is_utid_loading===true?
                                <li>
                                    <BeatLoader
                                        css={override}
                                        sizeUnit={"px"}
                                        size={5}
                                        color={'#666666'}
                                        loading={this.state.is_utid_loading}
                                    />
                                </li>: null}
                            {utid_lists}

                        </ul> </div>: null }
                {/*</div>*/}
            </div>

        );
    }
}

export default UtidFilter;